/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Undo</h4>

<p>Undo your last operation.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>Ctrl-Z</b>: Undo</li>
</ul>`;

export default function UndoTooltip() {
    return h('div', { innerHTML: body });
}
